import { stopPropagation } from '../../../../utils/events'
import {
  getWysiwygEditorCaretRect,
  restoreWysiwygEditorCaretViewportTop,
} from '../../../WysiwygEditor'
import { EMAIL_REPLY_FORM_WYSIWYG_CLASSNAME_HIDE_QUOTED_HISTORY } from '../../Email.constants'

export function useEmailReplyFormShowConversation({ editorRef }) {
  function toggleExpandConversation(event) {
    stopPropagation(event)

    editorRef.current
      .getBody()
      .classList.toggle(EMAIL_REPLY_FORM_WYSIWYG_CLASSNAME_HIDE_QUOTED_HISTORY)

    requestAnimationFrame(() => {
      const editor = editorRef.current

      const { top: caretTop } = getWysiwygEditorCaretRect(editor)

      editor.execCommand('mceAutoResize')

      restoreWysiwygEditorCaretViewportTop({ editor, top: caretTop })
    })
  }

  return { toggleExpandConversation }
}
